import { VALIDATION_START, VALIDATION_REQUEST, VALIDATION_DATE_CHECK_FAILURE, VALIDATION_SUCCESS, VALIDATION_FAILURE, VALIDATION_ABORT } from '../types';

const initialState = {
  status: 'initial',
  dateCheckMessage: '',
  message: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case VALIDATION_ABORT:
      return {
        ...state,
        status: 'initial',
        dateCheckMessage: '',
      };
    case VALIDATION_START:
      return {
        ...state,
        status: 'input',
        dateCheckMessage: '',
      };
    case VALIDATION_REQUEST:
      return {
        ...state,
        status: 'fetching',
      };
    case VALIDATION_SUCCESS:
      return {
        ...state,
        status: 'success',
        dateCheckMessage: '',
      };
    case VALIDATION_FAILURE:
      return {
        ...state,
        status: 'failure',
        message: action.payload,
      };
    case VALIDATION_DATE_CHECK_FAILURE:
      return {
        ...state,
        dateCheckMessage: action.payload,
      }
    default:
      return state;
  }
};
